/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES = 'sales';
/**
 * @deprecated prefer SALES_PROFESSIONAL
 * @see {@link ./ApiNames}
 */
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_PRO = 'sales-pro';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_STARTER = 'sales-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_PROFESSIONAL = 'sales-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_ENTERPRISE = 'sales-enterprise';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_STARTER_USER = 'sales-starter-user';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_PROFESSIONAL_USER = 'sales-professional-user';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_ENTERPRISE_USER = 'sales-enterprise-user';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING = 'marketing';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_STARTER = 'marketing-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_STARTER_EMAIL = 'marketing-starter-email';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_BASIC = 'marketing-basic';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_PRO = 'marketing-pro';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_ENTERPRISE = 'marketing-enterprise';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const STARTER_CONTACTS = 'starter-contacts';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BASIC_CONTACTS = 'basic-contacts';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_STARTER_CONTACTS = 'marketing-starter-contacts';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_PROFESSIONAL_CONTACTS = 'marketing-professional-contacts';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_ENTERPRISE_CONTACTS = 'marketing-enterprise-contacts';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE = 'service';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_STARTER = 'service-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_PROFESSIONAL = 'service-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_ENTERPRISE = 'service-enterprise';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_STARTER_USER = 'service-starter-user';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_PROFESSIONAL_USER = 'service-professional-user';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_ENTERPRISE_USER = 'service-enterprise-user';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const ADS = 'ads';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const ADS_CAPACITY = 'ads-capacity';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const WEBSITE = 'website';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const REPORTING = 'reporting';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const DEDICATED_IP = 'dedicated-ip';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const TRANSACTIONAL_EMAIL = 'transactional-email';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const ADDITIONAL_ACCOUNT = 'additional-account';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BRAND_DOMAIN = 'brand-domain';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const WORKFLOWS_ADDON = 'workflows-addon';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const LISTS_ADDON = 'lists-addon';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_SMS_ADDON = 'marketing-sms';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_SMS_SHORT_CODE = 'marketing-sms-short-code';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CUSTOM_SSL = 'custom-ssl';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const ESIGNATURE_LIMIT_INCREASE = 'esignature-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const DOMAINS_LIMIT_INCREASE = 'domains-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SANDBOX_LIMIT_INCREASE = 'sandbox-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CALLING_LIMIT_INCREASE = 'calling-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const PHONE_LIMIT_INCREASE = 'phone-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const TEAMS_LIMIT_INCREASE = 'teams-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const WHATSAPP_LIMIT_INCREASE = 'whatsapp-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const VIDEO_LIMIT_INCREASE = 'video-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_SMS_LIMIT_INCREASE = 'marketing-sms-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const WORKFLOWS_LIMIT_INCREASE = 'workflows-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const USERS_LIMIT_INCREASE = 'users-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CUSTOM_OBJECTS_LIMIT_INCREASE = 'custom-objects-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CALCULATED_PROPERTIES_LIMIT_INCREASE = 'calculated-properties-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CUSTOM_PROPERTIES_LIMIT_INCREASE = 'custom-properties-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CRM_OBJECT_LIMIT_INCREASE = 'crm-object-limit-increase';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CRM_CONTACT_RECORDS_LIMIT_INCREASE = 'non-marketing-contacts-limit-increase';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const DESIGNATED_TECHNICAL_SUPPORT = 'designated-technical-support';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const IN_PERSON_TRAINING = 'in-person-training';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const STARTER_KIT = 'starter-kit';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_PROFESSIONAL_ONBOARDING = 'sales-professional-onboarding';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_PROFESSIONAL_ONBOARDING = 'service-professional-onboarding';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const INBOUND_CONSULTING_BLOCK = 'inbound-consulting-block';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const TECHNICAL_CONSULTING_BLOCK = 'technical-consulting-block';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CMS_STARTER = 'cms-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CMS_ENTERPRISE = 'cms-enterprise';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CMS_PROFESSIONAL = 'cms-professional';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const OPERATIONS_STARTER = 'operations-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const OPERATIONS_PROFESSIONAL = 'operations-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const OPERATIONS_ENTERPRISE = 'operations-enterprise';

// Used only for free product activation
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CRM = 'crm';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SALES_FREE = 'sales-free';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_FREE = 'marketing-free';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SERVICE_FREE = 'service-free';

// Used for partner-program inquiries
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const PARTNER_PROGRAM = 'partner-program';

// For growth-suite purchases
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SUITE_STARTER = 'suite-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SUITE_PROFESSIONAL = 'suite-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const SUITE_ENTERPRISE = 'suite-enterprise';

// Marketing+ bundle
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_PLUS_PROFESSIONAL = 'marketing-plus-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const MARKETING_PLUS_ENTERPRISE = 'marketing-plus-enterprise';

// Used when feature can be unlocked by any enterprise SKU
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const ENTERPRISE = 'enterprise';
export const BUNDLE = 'bundle';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CORE_SEATS_STARTER = 'core-seats-starter';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CORE_SEATS_PROFESSIONAL = 'core-seats-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const CORE_SEATS_ENTERPRISE = 'core-seats-enterprise';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_100 = 'breeze-intelligence-credits-100';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_1000 = 'breeze-intelligence-credits-1000';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_10000 = 'breeze-intelligence-credits-10000';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED = 'breeze-intelligence-credits-100-committed';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED = 'breeze-intelligence-credits-1000-committed';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED = 'breeze-intelligence-credits-10000-committed';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100 = 'breeze-intelligence-overage-credits-for-100';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000 = 'breeze-intelligence-overage-credits-for-1000';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000 = 'breeze-intelligence-overage-credits-for-10000';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const HUBSPOT_CREDITS_COMMITTED = 'hubspot-credits-committed';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const HUBSPOT_CREDITS_COMMITTED_OVERAGE = 'hubspot-credits-committed-overage';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const HUBSPOT_CREDITS_OVERAGE = 'hubspot-credits-overage';

/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const COMMERCE_PROFESSIONAL = 'commerce-professional';
/**
 * @deprecated use ApiNames instead
 * @see {@link ./ApiNames}
 */
export const COMMERCE_ENTERPRISE = 'commerce-enterprise';